// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Kq-z","imageAndVideoCount":"Lq-z","imageAndVideoContainer":"Mq-z","viewAllReviews":"Nq-z"};